exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".seperator-x {\n  height: 2px;\n  background-color: #dbdbdb;\n}", ""]);

// exports
